module.exports = __webpack_public_path__ + "static/About-icon-1-Ateam-7c70fde10033cd33e8436654de8f6127.png";